const spaces = / /g;

export const createId = (text: string) => {
  const trimmed = text.trim();
  if (trimmed.length === 0) {
    throw new Error('Text needs to have at least one character');
  }
  return trimmed.replace(spaces, '-');
};
